///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { format as dateFormat } from "date-fns";

import { division, dateFormat as dateFormatTypes } from "./types";
import tlColumnConstants from "./tlColumnConstants";


export const round = number => {
  if (number !== null && isFinite(number)) {
    return Math.round(number * Math.pow(10, 2)) / Math.pow(10, 2);
  } else {
    return "";
  }
};

export const roundForNullableField = value => {
  if (value === null || !isFinite(value)) {
    return null;
  } else {
    return round(value);
  }
};

export const numberParse = value => ({
  value: parseFloat(value),
  isValid: !isNaN(parseFloat(value))
});

export const numberParseForEmptyValue = value => {
  if (value === "") {
    return { value: null, isValid: true };
  } else {
    return numberParse(value);
  }
};
export const getShiperMiles = (lane, { SHIPPER_DISTANCE, COYOTE_DISTANCE }) =>
  lane[SHIPPER_DISTANCE] ? lane[SHIPPER_DISTANCE] : lane[COYOTE_DISTANCE];

export const areNumbers = (lane, constants, fieldList) => {
  const { SHIPPER_DISTANCE } = constants;
  return fieldList.every(
    field =>
      !isNaN(
        field === SHIPPER_DISTANCE
          ? getShiperMiles(lane, constants)
          : lane[field]
      )
  );
};

export const formatDate = (value, userDivision) =>
  value &&
  dateFormat(
    new Date(value),
    userDivision === division.coy
      ? dateFormatTypes.MMddyy
      : dateFormatTypes.ddMMyy
  );

export const calculateRpm = ({ lane, constants }) => {
  const { TOTAL_RATE, RATE_PER_UNIT, SHIPPER_DISTANCE } = constants;
  if (areNumbers(lane, constants, [TOTAL_RATE, SHIPPER_DISTANCE])) {
    lane[RATE_PER_UNIT] = lane[TOTAL_RATE] / getShiperMiles(lane, constants);
  }
};

export const calculateFlatRate = ({ lane, changedBy, constants }) => {
  const {
    TOTAL_RATE,
    FLAT_RATE,
    BASE_RATE_PER_UNIT,
    FUEL_RATE,
    SHIPPER_DISTANCE
  } = constants;

  if (changedBy === BASE_RATE_PER_UNIT) {
    if (areNumbers(lane, constants, [SHIPPER_DISTANCE, BASE_RATE_PER_UNIT])) {
      lane[FLAT_RATE] =
        lane[BASE_RATE_PER_UNIT] * getShiperMiles(lane, constants);
    }
  } else {
    if (areNumbers(lane, constants, [TOTAL_RATE, FUEL_RATE])) {
      lane[FLAT_RATE] = lane[TOTAL_RATE] - lane[FUEL_RATE];
    }
  }
};

export const calculateBaseRpm = ({ lane, constants }) => {
  const { FLAT_RATE, BASE_RATE_PER_UNIT, SHIPPER_DISTANCE } = constants;
  if (areNumbers(lane, constants, [FLAT_RATE, SHIPPER_DISTANCE])) {
    lane[BASE_RATE_PER_UNIT] =
      lane[FLAT_RATE] / getShiperMiles(lane, constants);
  }
};

export const calculateCpm = ({ lane, constants }) => {
  const { TOTAL_COST, COYOTE_DISTANCE, COST_PER_UNIT } = constants;
  if (areNumbers(lane, constants, [TOTAL_COST, COYOTE_DISTANCE])) {
    lane[COST_PER_UNIT] = lane[TOTAL_COST] / lane[COYOTE_DISTANCE];
  }
};

export const calculateTotalCost = ({ lane, constants }) => {
  const { TOTAL_COST, COYOTE_DISTANCE, COST_PER_UNIT } = constants;
  if (areNumbers(lane, constants, [COST_PER_UNIT, COYOTE_DISTANCE])) {
    lane[TOTAL_COST] = lane[COST_PER_UNIT] * lane[COYOTE_DISTANCE];
  }
};

export const calculateRXOTotalCost = ({ lane, constants }) => {
  const { RXO_USA_TTT_COST, COYOTE_DISTANCE, COST_PER_UNIT } = constants;
  if (areNumbers(lane, constants, [COST_PER_UNIT, COYOTE_DISTANCE])) {
    lane[RXO_USA_TTT_COST] = lane[COST_PER_UNIT] * lane[COYOTE_DISTANCE];
  }
};


export const calculateRXOCpm = ({ lane }) => {
  const { RXO_USA_TTT_COST, COYOTE_DISTANCE, COST_PER_UNIT } = tlColumnConstants;
  if (areNumbers(lane, tlColumnConstants, [RXO_USA_TTT_COST, COYOTE_DISTANCE])) {
    lane[COST_PER_UNIT] = lane[RXO_USA_TTT_COST] / lane[COYOTE_DISTANCE];
  }
};